//?! VALIDATE PRICE
import store from '@shared/redux/store';
import { setValidationHotelPriceAlert } from '@shared/redux/actions';
import { AUX_VALIDATE_HOTEL, ENV } from '@shared/conf/env';

export const validateHotelAmount = ({
  idProduct,
  price,
  hotel,
  step,
  ratesAndBase,
}) => {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify({
    idProduct,
    amount: { price, hotel, step },
    ratesAndBase,
    env: ENV,
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  return new Promise(resolve => {
    fetch(AUX_VALIDATE_HOTEL + '/hotel/validate', requestOptions)
      .then(response => response.json())
      .then(result => {
        //resolve(result)
        console.log('Amount validation result', result);
        resolve(result);
      })
      .catch(error => {
        console.log('Error validating hotel amount:', error);
        store.dispatch(
          setValidationHotelPriceAlert({
            wrong: true,
          })
        );
        resolve({ wrong: true });
      });
  });
};
//?! VALIDATE PRICE

export const saveProblemFront = async data => {
  try {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify(data);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };
    fetch(AUX_VALIDATE_HOTEL + '/wrong', requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.error(error));
  } catch (err) {
    console.error('Error enviando problema al backend', err);
  }
};
